import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent, OpalApiRequestBody } from '../../schema'

type RequestAttributes =
  OpalApiRequestBody<'CreateMomentCustomFieldV3'>['data']['attributes']
type RequestRelationships =
  OpalApiRequestBody<'CreateMomentCustomFieldV3'>['data']['relationships']

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'moment_custom_field'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

const defaultBoardAttributes: OptionalAttributes = {
  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),
}

export const resourceObject = ({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'moment_custom_field'> => {
  return {
    id: uuidv4(),
    type: 'moment_custom_field',
    attributes: {
      ...defaultBoardAttributes,
      ...attributes,
    },
    relationships: {
      ...relationships,
    },
  }
}
